/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />


//Used as an attribute on the first input that should have focus
module Meevo.Components.Controls {
    "use strict";

    export class MeevoAutoFocus implements angular.IDirective {
        restrict = "A";

        
        link = (scope: any, element: JQuery, attrs: angular.IAttributes) => {
            var autoFocusDelay;
            var setFocus = () => {
                if (!/Mobile/i.test(navigator.userAgent) && !/ipad/i.test(navigator.userAgent) && !/android/i.test(navigator.userAgent)) {
                    // due to styling, you have to find the input element inside the directive before you set focus
                    // added setTimeout to reorder  UI thread stack so it autofocus when element is not on page yet
                    window.setTimeout(() => { // need the timeout to push the UI thread up the stack so the field is made active before trying to set focus
                        element.find('input').focus();
                    }, attrs['autoFocusDelay']);
                };
            };

            var setFocusAtEnd = () => {
                if (!/Mobile/i.test(navigator.userAgent) && !/ipad/i.test(navigator.userAgent) && !/android/i.test(navigator.userAgent)) {
                    window.setTimeout(() => { 
                        var elem: any = element.find('input');
                        elem.focus();
                        elem[0].setSelectionRange(elem[0].value.length, elem[0].value.length)
                        
                    });
                };
            }

            if (!_.isUndefined(attrs['isEditing'])) {
                scope.$watch(function () {
                    return attrs['isEditing'] }, function (newVal) {
                        if (newVal) {
                            setFocusAtEnd();
                        }
                });
            }

            element.keydown((event: KeyboardEvent) => {
                if (event.which === 9 || event.keyCode === 9) {
                    let last: JQuery = element.find('.focus-last').first(),
                        first: JQuery = element.find('.focus-first').first();

                    if (event.shiftKey) {
                        if (first && first.is(':focus')) {
                            event.preventDefault();
                            element.find('.focus-last').focus();
                        }
                    } else {
                        if (last && last.is(':focus')) {
                            event.preventDefault();
                            setFocus();
                        }
                    }
                }
            });

            // StephenM: Uncomment this to work on toggling to edit for the first field. Disabled because it causes the screen to jump to the first field if you're scrolled
            // Uncommented for story 49051: cursor move to field when toggle to edit
            if (attrs['ngDisabled']) {
                scope.$watch('context.isReadonly', () => {
                    if (scope.context && !scope.context.isReadonly) {
                        setTimeout(() => {
                            setFocus();
                        });
                    }
                });
            }

            if (attrs['preventFirstFocus'] !== "true") {
                setFocus();
            }
            if (attrs['autoFocusDelay'] == undefined) {
                autoFocusDelay = 50;
            }
        }

        static factory(): angular.IDirectiveFactory {
            let directive = () => {
                return new MeevoAutoFocus();
            };
            
            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoAutoFocus", MeevoAutoFocus.factory());
}